// ─────────────────────────────────────────────────────────────────────────────
// Precarga de los formularios que escriben directo en el DOM
//
// Las fichas de producto y de accesorio cargan sus campos con
// `document.getElementById(id).value = ...`, una línea por campo. Si un id deja de existir —lo
// esconde un render condicional, se renombra, se saca— esa línea tira `TypeError` y, como la
// precarga corre dentro de un `.then` sin `.catch`, se lleva puesta TODA la cadena: los campos
// que venían después, el `setState` final y lo que se llamara a continuación. La ficha queda a
// medio cargar sin un solo cartel, y lo único que se ve es que "los campos vienen vacíos".
//
// Pasó en producción entre el 2026-09-08 y el 2026-09-17 (release 2.25.0): el `<input id="stock">`
// pasó a renderizarse sólo en el alta y `loadData` le siguió escribiendo en edición, así que la
// ficha de producto perdió 20 de sus 24 campos para cualquier administrador.
//
// Este helper corta el efecto dominó: un campo que falta se anota y la precarga sigue. Tolerar
// es, por definición, enmascarar — así que la contrapartida NO es opcional y va del lado de
// quien llama: si `faltantes()` no está vacío, la ficha no se puede guardar. Ese es el punto.
// Un formulario a medio cargar sólo puede pisar datos buenos con los defaults del markup, y los
// defaults no los ataja ninguna validación: un `<select>` nunca está "vacío", está MAL, que es
// distinto.
// ─────────────────────────────────────────────────────────────────────────────

export function crearPrecarga(rotulo = 'ficha') {
    const faltantes = [];

    return {
        /** Escribe `value` en el campo `id`. Si el campo no está, lo anota y sigue. */
        set(id, value) {
            const el = document.getElementById(id);
            if (el == null) {
                faltantes.push(id);
                console.error(
                    `[${rotulo}] no existe el campo #${id}: la precarga queda incompleta y el `
                    + 'guardado va a bloquearse. Suele significar que el render lo condicionó '
                    + '(por rol, por alta/edición, por un flag) y la precarga no se enteró.',
                );
                return false;
            }
            el.value = value;
            return true;
        },

        /** Los ids que no se pudieron escribir. Vacío = la ficha cargó completa. */
        faltantes() {
            return faltantes.slice();
        },
    };
}
